import { defineRecipe } from '@chakra-ui/react';
import { TextStyles } from '../../types';

const sizeStyles = {
  h0: { textStyle: TextStyles.H0 },
  h1: { textStyle: TextStyles.H1 },
  h2: { textStyle: TextStyles.H2 },
  h3: { textStyle: TextStyles.H3 },
  h4: { textStyle: TextStyles.H4 },
  h5: { textStyle: TextStyles.H5 },
  h6: { textStyle: TextStyles.H6 },
};

export const headingRecipe = defineRecipe({
  base: {
    color: 'text-emphasis',
  },
  variants: {
    // The heading scale is exposed via both `size` and `variant`.
    size: sizeStyles,
    variant: sizeStyles,
  },
});
